/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VisibilityEnum } from './visibility-enum';
import { LabelRequest } from './label-request';
import { DeckPitchDetailRequestLimitPaymentOptionsTo } from './deck-pitch-detail-request-limit-payment-options-to';
import { DeckCompanyRequest } from './deck-company-request';

export interface DeckPitchDetailRequest {
  id: string;
  name: string;
  company: DeckCompanyRequest;
  min_goal?: string | null;
  max_goal?: string | null;
  /**
   * Pitches are closed every half hour
   */
  end_day?: string | null;
  /**
   * public - visible for every user; unlisted - accessible only from direct link; private - visible only for admins; coming up - visible but not accessible;draft -
   */
  visibility?: VisibilityEnum;
  share_price?: string | null;
  featured?: boolean;
  first_end_date?: string | null;
  start_date?: string | null;
  labels: Array<LabelRequest>;
  homepage?: string | null;
  tax_deducted?: boolean | null;
  general_meeting_date?: string | null;
  payment_due?: string | null;
  threshold_value?: string | null;
  investment_step?: string | null;
  limit_payment_options_to?: DeckPitchDetailRequestLimitPaymentOptionsTo | null;
  max_per_investor?: string | null;
  min_per_investor?: string | null;
  require_vps?: boolean;
  account_number?: string;
  short_description?: string;
  /**
   * banner used with pitch
   */
  banner?: Blob;
  photo?: Blob | null;
  seo_image?: Blob;
  pre_money_eval?: string | null;
}
export namespace DeckPitchDetailRequest {}
